import React from 'react';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';
import styled from 'styled-components';

const CbtDescriptionMobile = ({ examInfo }: any) => {
  const { examName, institution, examDetailCount, problemCount, viewCount, description, examUrl } =
    examInfo;
  const { logo } = useRecoilValue(projectConfigState);
  return (
    <StyledWrapper examUrl={examUrl ?? logo}>
      <div className="title-wrapper">
        <h1 className="title"> {examName} </h1>
      </div>
      <article className="description-wrapper">
        <section>
          <dl>
            <dt>시행기관</dt>
            <dd>{institution}</dd>
            <dt>총 회차</dt>
            <dd>{Number(examDetailCount).toLocaleString()}</dd>
            <dt>총 문제수</dt>
            <dd>{Number(problemCount).toLocaleString()}</dd>
            <dt>조회수</dt>
            <dd>{Number(viewCount).toLocaleString()}</dd>
            {description && (
              <>
                <dt>시험설명</dt>
                <dd className="description" dangerouslySetInnerHTML={{ __html: description }}></dd>
              </>
            )}
          </dl>
        </section>
      </article>
    </StyledWrapper>
  );
};

export default CbtDescriptionMobile;

const StyledWrapper = styled.div<{ examUrl: string }>`
  display: none;
  @media ${({ theme }) => theme.device.mobile} {
    display: block;
  }
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 70px 20px 20px;
    margin-bottom: 20px;
    background: linear-gradient(to top, rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0)),
      url(${({ examUrl }) => examUrl});
    background-size: cover;
    background-position: center;

    .title {
      font-size: 24px;
      font-weight: 600;
      margin: 0;
      color: #fff;
    }
  }
  .description-wrapper {
    padding: 0 20px;

    > section {
      dl {
        width: 100%;
        dt {
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          font-weight: 300;
          color: #666;
          width: 25%;
          margin: 14px 0 0 0;
          &:first-of-type {
            margin-top: 0;
          }
        }
        dd {
          display: inline-block;
          font-size: 16px;
          color: #333;
          width: 75%;
          margin: 14px 0 0 0;
          &:first-of-type {
            margin-top: 0;
          }
          &:last-of-type {
            white-space: pre-wrap;
            line-height: 22px;
          }
        }
        .description {
          ul {
            * {
              word-break: keep-all;
            }
          }
        }
      }
    }
  }
`;
